import cssVariables from '@/assets/cssVariables.json';
import {
    CommercialAndIndustrialResearchNames,
    ResidentialResearchNames,
    SectionRouteNames,
    SectionRouteNamesResearch,
} from '@/routes/sectionRoutes/sectionRouteNames.ts';
import { sectionRoutes } from '@/routes/sectionRoutes/sectionRoutes.ts';

export const SITE_AREA_RELEVANCE_OPTIONS: Array<SectionRouteNames> = [
    SectionRouteNames.powerAndStorage,
    SectionRouteNames.networks,
    SectionRouteNames.commercialAndIndustrial,
    SectionRouteNames.residential,
    SectionRouteNames.evs,
    SectionRouteNames.flexibility,
];

export const SITE_RELEVANCE_BY_SUBSCRIPTION_FILTER_ID: Record<string, SectionRouteNames> = {
    powerAndStorage: SectionRouteNames.powerAndStorage,
    cAndI: SectionRouteNames.commercialAndIndustrial,
    residential: SectionRouteNames.residential,
    evs: SectionRouteNames.evs,
};

const SECTION_STYLE_KEY_BY_ROUTE_NAME: Record<SectionRouteNames, keyof typeof cssVariables.sectionColors> = {
    [SectionRouteNames.powerAndStorage]: 'powerAndStorage',
    [SectionRouteNames.networks]: 'networks',
    [SectionRouteNames.commercialAndIndustrial]: 'commercialAndIndustrial',
    [SectionRouteNames.residential]: 'residential',
    [SectionRouteNames.evs]: 'evCharging',
    [SectionRouteNames.flexibility]: 'flexibility',
};

const SECTION_RELEVANCE_ROUTE_ALIASES: Partial<Record<SectionRouteNamesResearch, SectionRouteNames>> = {
    [ResidentialResearchNames.evChargingResearch]: SectionRouteNames.evs,
    [ResidentialResearchNames.residentialAll]: SectionRouteNames.residential,
    [CommercialAndIndustrialResearchNames.commercialAndIndustrialAll]: SectionRouteNames.commercialAndIndustrial,
};

export function getSectionRouteForSiteAreaRelevance (sectionRouteName: string | null | undefined): SectionRouteNames | null {
    if (!sectionRouteName) return null;
    if (Object.values(SectionRouteNames).includes(sectionRouteName as SectionRouteNames)) return sectionRouteName as SectionRouteNames;

    return SECTION_RELEVANCE_ROUTE_ALIASES[sectionRouteName as SectionRouteNamesResearch] ?? null;
}

export function getSiteAreaRelevanceLabel (siteArea: string): string {
    return String(sectionRoutes[siteArea as SectionRouteNames]?.meta?.headName ?? siteArea);
}

export function getSubscriptionFilterIdForSiteArea (siteArea: string): string | null {
    return Object.entries(SITE_RELEVANCE_BY_SUBSCRIPTION_FILTER_ID)
        .find(([, mappedSiteArea]) => mappedSiteArea === siteArea)?.[0] ?? null;
}

export function getSiteAreaRelevanceColour (siteArea: string): string {
    const sectionKey = SECTION_STYLE_KEY_BY_ROUTE_NAME[siteArea as SectionRouteNames];
    return sectionKey ? cssVariables.sectionColors[sectionKey] : cssVariables.lcpColors.lcpBlue;
}

export function getSiteAreaRelevanceIcon (siteArea: string): string {
    const sectionKey = SECTION_STYLE_KEY_BY_ROUTE_NAME[siteArea as SectionRouteNames];
    return sectionKey ? cssVariables.sectionFaIcons[sectionKey] : 'circle';
}
